<template>
  <section class="spartan-home sp-contact">
    <SpartanHeader />

    <div class="container-wide">
      <div class="content">
        <SpartanNavigation />

        <div class="banner">
         <picture>
            <source
              media="(max-width:480px)"
              srcset="../assets/spartan-banners/spartan-contact-square.jpg"
              alt="contact Spartan Builders"
            />
            <source
              media="(min-width:480px)"
              srcset="../assets/spartan-banners/spartan-contact.jpg"
              alt="contact Spartan Builders"
            />
            <img
              src="../assets/spartan-banners/spartan-contact.jpg"
              alt="contact Spartan Builders"
            >
         </picture>
        </div>

        <div class="copy">
          <h2>Your Request Has Been Sent</h2>
           <p>
              Your form has successfully been sent to staff at Spartan Builders. 
          </p>
          
          <p>
            Whether you need help right now, have building questions, or have
            future projects that need an experienced builder, please contact us.
            You may also call our main number at
            <a href="tel:+18177580470" class="telephone-link">(817) 754-0470</a
            >. For help right now call Bryant Rose at
            <a href="tel:+16825519674" class="telephone-link">(682) 551-9674</a
            >.
          </p>
        </div>
      </div>
    </div>

    <SpartanFooter />
  </section>
</template>

<script>
import SpartanHeader from "@/components/SpartanHeader.vue";
import SpartanNavigation from "@/components/SpartanNavigation.vue";
import SpartanFooter from "@/components/SpartanFooter.vue";

export default {
  name: "SpartanHome",
  components: {
    SpartanHeader,
    SpartanNavigation,
    SpartanFooter
  }
};
</script>

<style lang="scss">
.content {
  background: #7a7a75;
  min-height: 50vh;
}

.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #fff;
}

.banner {
  width: 100%;
}

.banner > img,
.banner > picture {
  width: 100%;
  height: auto;
}
</style>
